<template >
  <div id="app" v-bind:class="{ 'image-background-login': !auth.isLoggedIn }">
    <app-sidebar></app-sidebar>
    <div class="content-page" v-bind:class="{ 'full-width': !auth.isLoggedIn }">
      <div class="content">
        <app-nav></app-nav>
        <router-view></router-view>
      </div>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
  import AppNav from './AppNav.vue'
  import AppFooter from './AppFooter.vue'
  import AppSidebar from './AppSidebar.vue'

  export default {
    name: 'app',
    components: {
      AppSidebar, AppNav, AppFooter
    },
    data () {
      return {
        auth: this.$store.state.auth
      }
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    color: #2c3e50;
  }
  #app>div.container {
    margin-top: 30px;
  }
  .full-width {
    margin-left: auto;
  }
  .image-background-login {
    background: url("/static/images/background.jpg");
    background-size: cover;
    min-height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/App.vue